export const request = async (url, options) => {
    const response = await fetch(url,{
      method: !options ? 'GET': options.method,
      body: options?.body,
      headers :{
        // "Content-Type": "application/json"
      }
    })
    return checkReponse(response);
  };
export const checkReponse = (res) => {
    return res.ok ? res.json() : res.json().then((err) => Promise.reject(err));
  };